 const dateFilterOptions = {
  options: ["daily", "weekly", "monthly", "yearly"],
  initial: "yearly",
};

export default dateFilterOptions;